import { Component, OnInit } from '@angular/core';
import { WordpressService } from '../../../services/wordpress.service';
import { BackdropCard, SceneCard } from '../../../models/service.model';

@Component({
  selector: 'app-filming-in-oman',
  templateUrl: './filming-in-oman.component.html',
  styleUrls: ['./filming-in-oman.component.scss']
})
export class FilmingInOmanComponent implements OnInit {
  backdrops: BackdropCard[] = [];
  backdropsLoading = true;
  backdropsError: string | null = null;
  backdropSkeletonItems = Array.from({ length: 3 });

  scenes: SceneCard[] = [];
  scenesLoading = true;
  scenesError: string | null = null;
  sceneSkeletonItems = Array.from({ length: 4 });

  constructor(private wordpressService: WordpressService) { }

  ngOnInit(): void {
    this.loadBackdrops();
    this.loadScenes();
  }

  private loadBackdrops(): void {
    this.wordpressService.getBackdrops().subscribe({
      next: backdrops => {
        this.backdrops = backdrops;
        this.backdropsLoading = false;
      },
      error: err => {
        this.backdropsError = this.formatError(err, 'Unable to fetch backdrops from WordPress.');
        this.backdropsLoading = false;
      }
    });
  }

  private loadScenes(): void {
    this.wordpressService.getScenes().subscribe({
      next: scenes => {
        this.scenes = scenes;
        this.scenesLoading = false;
      },
      error: err => {
        this.scenesError = this.formatError(err, 'Unable to fetch scenes from WordPress.');
        this.scenesLoading = false;
      }
    });
  }

  trackByBackdrop(index: number, item: BackdropCard): number {
    return item.id;
  }

  trackByScene(index: number, item: SceneCard): number {
    return item.id;
  }

  /* True only for a final item left alone on its own row in the 2-column (col-sm-6)
     layout, so it gets centered the same way the original 3rd static item was —
     generalizes correctly for any item count, not just 3. Same helper already used
     by HomeThreeComponent for Blink Productions, which shares the same col-sm-6
     col-lg-4 grid. */
  needsSmOffset(index: number, total: number): boolean {
    return index === total - 1 && index % 2 === 0;
  }

  private formatError(err: any, fallback: string): string {
    if (err?.status) {
      return `${err.status} ${err.statusText || 'Error'}${err.error?.message ? ' - ' + err.error.message : ''}`;
    }

    return err?.message || fallback;
  }

}
